<svg class="icon" [ngStyle]="iconStyle">
  <use attr.xlink:href="/dist/tiime-material/assets/twocolors-sprite.svg#{{ icon }}"></use>
</svg>
